import React from 'react'
import { Box, TextField, Typography } from '@mui/material'

import { ContactInfoStepProps } from '../types'

const ContactInfoStep: React.FC<ContactInfoStepProps> = ({ name, email, phone, weChat, onChange, errors }) => {
  const textFieldSx = {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      '& fieldset': {
        borderColor: '#e0e2ef',
      },
      '&:hover fieldset': {
        borderColor: '#c1c7d0',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#050a22',
        borderWidth: '1px',
      },
      '&.Mui-error fieldset': {
        borderColor: '#d32f2f',
      },
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#050a22',
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 14px',
    },
  }

  return (
    <Box className="flex flex-col gap-6">
      <Box className="flex flex-col gap-2">
        <Typography variant="h5" className="font-bold text-gray-900">
          Contact Information
        </Typography>
      </Box>

      <Box className="flex flex-col gap-4">
        <Box>
          <Typography variant="body1" className="font-semibold text-gray-900 mb-2">
            Full Name (First &amp; Last)
          </Typography>
          <TextField
            fullWidth
            placeholder="Your answer"
            value={name}
            onChange={e => onChange({ name: e.target.value })}
            error={errors?.name}
            helperText={errors?.name ? 'Please enter your full name.' : ''}
            variant="outlined"
            size="medium"
            sx={textFieldSx}
          />
        </Box>

        <Box>
          <Typography variant="body1" className="font-semibold text-gray-900 mb-2">
            Email
          </Typography>
          <TextField
            fullWidth
            type="email"
            placeholder="Your answer"
            value={email}
            onChange={e => onChange({ email: e.target.value })}
            error={errors?.email}
            helperText={errors?.email ? 'Please enter a valid email address.' : ''}
            variant="outlined"
            size="medium"
            sx={textFieldSx}
          />
        </Box>

        <Box>
          <Typography variant="body1" className="font-semibold text-gray-900 mb-2">
            Phone Number
          </Typography>
          <TextField
            fullWidth
            type="tel"
            placeholder="Your answer"
            value={phone}
            onChange={e => onChange({ phone: e.target.value })}
            error={errors?.phone}
            helperText={errors?.phone ? 'Please enter a valid US phone number (e.g. 123-456-7890).' : ''}
            variant="outlined"
            size="medium"
            sx={textFieldSx}
          />
        </Box>

        <Box>
          <Typography variant="body1" className="font-semibold text-gray-900 mb-2">
            WeChat
          </Typography>
          <TextField
            fullWidth
            placeholder="Your answer"
            value={weChat}
            onChange={e => onChange({ weChat: e.target.value })}
            variant="outlined"
            size="medium"
            sx={textFieldSx}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default ContactInfoStep
